import { isDashboardQueryKey } from './DashboardQueryCatalog';
import type { DashboardQueryKey } from './DashboardQueryCatalog';

/** The connector `type` a server-fed connector is authored under. */
export const PROVIDER_CONNECTOR_TYPE = 'Provider';

/** One `layout.dataPool.connectors[]` entry. */
export interface DashboardLayoutConnector {
    id?: string;
    type?: string;
    queryKey?: string;
    params?: Record<string, unknown>;
    [key: string]: unknown;
}

/** A `Provider` connector. */
export type DashboardProviderConnector = DashboardLayoutConnector & {
    id: string;
    type: typeof PROVIDER_CONNECTOR_TYPE;
    queryKey: DashboardQueryKey;
};

/** Whether a pool entry read out of a stored layout is a connector this platform feeds. */
export function isProviderConnector(connector: DashboardLayoutConnector): connector is DashboardProviderConnector {
    return connector.type === PROVIDER_CONNECTOR_TYPE && connector.id !== undefined && isDashboardQueryKey(connector.queryKey);
}

/** One `layout.components[]` entry. */
export interface DashboardLayoutComponent {
    renderTo?: string;
    type?: string;
    widgetKey?: string;
    queryKey?: string;
    queryParams?: Record<string, unknown>;
    connector?: { id?: string };
    widgetConfig?: Record<string, unknown>;
    [key: string]: unknown;
}

export interface DashboardLayoutBlob {
    dataPool?: { connectors?: DashboardLayoutConnector[] };
    components?: DashboardLayoutComponent[];
    [key: string]: unknown;
}
